import React from "react";
import { Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomPrimaryButton from "../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import { dentalIcons } from "../dentail-indetifcation/utils-icons/dentalIcons";

const SubscriptionExpired = () => {
  const navigate = useNavigate();
  const privileges = useSelector((state) => state.auth?.privileges);
  const planType = privileges?.planType; // "trial" or "stripe"

  const renderSubTitle = () => {
    if (planType == "trial") {
      return (
        <div style={{ fontSize: 14, color: "#666" }}>
          Your trial period has ended. To continue using the Dental
          Identification features, please subscribe to a paid plan.
        </div>
      );
    }

    if (planType === "stripe") {
      return (
        <div style={{ fontSize: 14, color: "#666" }}>
          Your subscription has expired and access to this section is currently
          restricted.
          <br />
          Please renew your subscription to continue using the Dental
          Identification features.
        </div>
      );
    }

    // Default fallback
    return (
      <div style={{ fontSize: 14, color: "#666" }}>
        Your access to this section is currently restricted due to an inactive
        subscription.
        <br />
        Please contact support or subscribe to continue.
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8f9fb]">
      <Result
        icon={
          <img
            src={dentalIcons.subscriptionExpired}
            alt="Subscription Expired"
            style={{ width: 400, objectFit: "contain" }}
          />
        }
        title="Subscription Expired"
        subTitle={renderSubTitle()}
        extra={
          <CustomPrimaryButton
            title="Subscribe Now"
            onClick={() => navigate("/subscription")}
            width={"100%"}
          />
        }
      />
    </div>
  );
};

export default SubscriptionExpired;
